export const lightColors = {
  primary: "#000000",
  background: "#FFFFFF",
  buttonText: "#FFFFFF",
  themeToggle: "#F1F1F1",
  mainHeading: "#1F1F1F",
  mainText: "#545454",
  socialBg: "#313131",
  inputBg: "#E1E1E1",
  line: "#9B9B9B",
  // Add more colors as needed
};

export const darkColors = {
  primary: "#000000",
  background: "#FFFFFF",
  buttonText: "#FFFFFF",
  themeToggle: "#F1F1F1",
  mainHeading: "#1F1F1F",
  mainText: "#545454",
  socialBg: "#313131",
  inputBg: "#E1E1E1",
  line: "#9B9B9B",
  // Add more colors as needed
};

export const getColors = (isDarkMode) =>
  isDarkMode ? darkColors : lightColors;
